import { api } from "@/api";
import { virtualStreamPath } from "./virtualSportType";

export interface VirtualStandingRow {
  pos: number;
  team: string;
  // VFL team uid (= logo teamid) for the team crest; 0/absent → no logo.
  teamUid?: number;
  played: number;
  win: number;
  draw: number;
  loss: number;
  goalsFor: number;
  goalsAgainst: number;
  points: number;
}

// League standings (Puan Durumu) for a VR league.
export const getVirtualStandings = async (
  leagueId: number
): Promise<VirtualStandingRow[]> => {
  const res = await api.client.get(
    virtualStreamPath("virtual-football", "standings"),
    { params: { leagueId } }
  );
  return res.data?.standings ?? [];
};
